import { render, staticRenderFns } from "./NewCustomTag.vue?vue&type=template&id=220edb60&scoped=true&"
import script from "./NewCustomTag.vue?vue&type=script&lang=js&"
export * from "./NewCustomTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220edb60",
  null
  
)

export default component.exports